'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _has = require('lodash/has');

var _has2 = _interopRequireDefault(_has);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _set = require('lodash/set');

var _set2 = _interopRequireDefault(_set);

var _merge = require('lodash/fp/merge');

var _merge2 = _interopRequireDefault(_merge);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultData = {
  activeLocale: null,
  locale: {}
};

var MemoryStorage = function () {
  function MemoryStorage() {
    var initialData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultData;

    _classCallCheck(this, MemoryStorage);

    this.data = initialData;
  }

  /**
   * get scope text value
   *
   * @param {string} scope
   * @param {LocaleOption} option
   * @returns {string}
   * @memberof MemoryStorage
   */

  /**
   * @type {Data}
   * @memberof MemoryStorage
   */


  _createClass(MemoryStorage, [{
    key: 'getText',
    value: function getText(scope) {
      var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var defaultValue = option.defaultValue;

      return (0, _get2.default)(this.data, this._getTextPath(scope, option), defaultValue);
    }

    /**
     * @param {string} scope
     * @param {string} value
     * @param {LocaleOption} option
     * @returns {string}
     * @memberof MemoryStorage
     */

  }, {
    key: 'setText',
    value: function setText(scope, value) {
      var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return (0, _set2.default)(this.data, this._getTextPath(scope, option), value);
    }
  }, {
    key: 'addLanguageScope',
    value: function addLanguageScope(language, textByScope) {
      (0, _set2.default)(this.data, this._getLanguagePath(language), (0, _merge2.default)((0, _get2.default)(this.data, this._getLanguagePath(language)), textByScope));
      return this;
    }

    /**
     * @param {string} scope
     * @param {LocaleOption} option
     * @returns {bool}
     * @memberof MemoryStorage
     */

  }, {
    key: 'hasText',
    value: function hasText(scope) {
      var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return (0, _has2.default)(this.data, this._getTextPath(scope, option));
    }
    /**
     * @returns {string}
     * @memberof MemoryStorage
     */

  }, {
    key: 'getActiveLocale',
    value: function getActiveLocale() {
      return this.data.activeLocale;
    }

    /**
     * @param {string} newActiveLocale
     * @returns {string}
     * @memberof MemoryStorage
     */

  }, {
    key: 'setActiveLocale',
    value: function setActiveLocale(newActiveLocale) {
      this.data.activeLocale = newActiveLocale;
      return this.data.activeLocale;
    }
  }, {
    key: '_getLanguagePath',
    value: function _getLanguagePath(language) {
      return 'locale.' + language;
    }

    /**
     * @param {string} scope
     * @param {LocaleOption} option
     * @returns {string}
     * @memberof MemoryStorage
     */

  }, {
    key: '_getTextPath',
    value: function _getTextPath(scope, option) {
      var _language = option.language;

      var language = (0, _isEmpty2.default)(_language) ? this.getActiveLocale() : _language;
      if (!language) {
        throw new Error('Language is empty');
      }
      return this._getLanguagePath(language) + '.' + scope;
    }
  }]);

  return MemoryStorage;
}();

exports.default = MemoryStorage;
module.exports = exports['default'];